import { Suspense } from "react";
import { Outlet } from "react-router";
import { PageLoader } from "../components/PageLoader";
import { ChunkErrorBoundary } from "../../components/ChunkErrorBoundary";

export function BareLayout() {
  return (
    <ChunkErrorBoundary>
      <Suspense fallback={<PageLoader />}>
        <Outlet />
      </Suspense>
    </ChunkErrorBoundary>
  );
}
